import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const HowItWorks = () => {
  const steps = [
    'Kampus menyetujui penggunaan Wisuda.ai',
    'Panitia menyiapkan QR Code resmi',
    'Peserta scan dan terhubung ke WhatsApp',
    'AI menyampaikan informasi & menerima partisipasi',
    'Arsip kenangan digital diserahkan ke kampus'
  ];

  return (
    <section id="cara-kerja" className="py-24 px-6 bg-gradient-to-br from-sage-50 to-cream-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Cara Kerja Wisuda.ai
          </h2>
        </div>
        
        <div className="relative">
          <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-gradient-to-b from-sage-300 to-terracotta-300 hidden md:block"></div>
          
          <div className="space-y-8">
            {steps.map((step, index) => (
              <div 
                key={index}
                className="relative flex items-start gap-6 group"
              >
                <div className="flex-shrink-0 w-16 h-16 bg-white rounded-full border-4 border-sage-200 flex items-center justify-center shadow-md group-hover:border-sage-400 transition-colors z-10">
                  <span className="text-2xl font-bold text-sage-600">{index + 1}</span>
                </div>
                
                <div className="flex-1 p-6 bg-white rounded-xl border-2 border-cream-200 group-hover:border-sage-300 transition-all duration-300 shadow-sm group-hover:shadow-md">
                  <p className="text-lg text-gray-800 font-medium">
                    {step}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        <div className="mt-12 text-center p-6 bg-white rounded-2xl border-2 border-sage-200">
          <div className="flex items-center justify-center gap-2 mb-2">
            <CheckCircle2 className="w-6 h-6 text-sage-600" />
            <p className="text-lg font-semibold text-gray-900">
              Semua proses berlangsung tertib dan terkontrol
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
